export enum ProductionParkType {
  SOLAR = "SOLAR",
  WIND = "WIND",
  HYBRID = "HYBRID",
}
